import Overview from './svg/NewOverview.svg';
export default function WelcomeOverview(){
  return(
    <div class="flex-expand h-center" style={{
      
      position:'relative',
      width:'100%',
      minHeight:0,
      maxHeight:'100%',
      //height:'100%',
      //border:'3px solid red',
      //overflowY:'scroll',
      }}>
      <div style={{position:'relative',
        overflowY:'scroll',
        height:'90%',
        }} class="full-width full-width sg-row h-center">
      {true && <img style={{
        //height:'80%',
        //border:'3px solid magenta',
        objectFit:'contain',
        minHeight:0,
      }} src={Overview}
        class=""
        />}
        </div>
    </div>
  )
}
